import React, { useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import StatsSection from './components/StatsSection';
import ServicesSection from './components/ServicesSection';
import CreatorsGallery from './components/CreatorsGallery';
import WebSeriesCarousel from './components/WebSeriesCarousel';
import YouTubeChannels from './components/YouTubeChannels';
import ClientLogos from './components/ClientLogos';
import GlobalPresence from './components/GlobalPresence';
import InstagramHandles from './components/InstagramHandles';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

function App() {
  useEffect(() => {
    // Parallax effect for hero
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const hero = document.querySelector('.hero-parallax');
      if (hero) {
        hero.style.transform = `translateY(${scrolled * 0.5}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="App" style={{ margin: 0, padding: 0 }}>
      <Header />
      <HeroSection />
      <AboutSection />
      <StatsSection />
      <ServicesSection />
      <CreatorsGallery />
      <WebSeriesCarousel />
      <YouTubeChannels />
      <ClientLogos />
      <GlobalPresence />
      <InstagramHandles />
      <ContactForm />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
